import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { AuthAPI, GlobalMpAuth } from '@cibo/core'
import { VerticalSpace } from '@cibo/ui'

import { authCheckSuccess, refreshUserInfo } from '../../store'
import EmulateUserForm, { EmulationUserQuery } from './EmulateUserForm'

import { FormHelperText } from '@mui/material'

type EmulateUserFormProps = {
  onSuccess?(): void
  onCancel?(): void
}

export const EmulateUserFormContainer = ({ onSuccess, onCancel }: EmulateUserFormProps) => {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | undefined>()

  const onSubmit = async (values: EmulationUserQuery) => {
    if (!values.username && !values.userId) {
      setError('Please specify an email or a user id.')
      return
    }
    setLoading(true)
    try {
      const response = await AuthAPI.emulateUser(values.username, values.userId)
      if (response && response.data) {
        const data = response.data
        setError(undefined)

        data.userJwt && GlobalMpAuth.setAuthToken(data.userJwt)

        dispatch(authCheckSuccess(response))
        dispatch(refreshUserInfo())
      }
    } catch (error: any) {
      setError(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {error && <FormHelperText error>{error}</FormHelperText>}
      <VerticalSpace />
      <EmulateUserForm
        isLoading={loading}
        onSubmit={onSubmit}
        onCancel={onCancel}
        onSuccess={onSuccess}
      />
    </>
  )
}

export default EmulateUserFormContainer
